import { isFeatureEnabled } from 'owa-feature-flags';
import {
    getOptionsForFeature,
    OwsOptionsFeatureType,
    BohemiaOptions,
} from 'owa-outlook-service-options';

export enum BohemiaEnabledScenario {
    MailReadingPane,
    MailCompose,
    CalendarCompose,
}

export default function isBohemiaEnabledForScenario(scenario: BohemiaEnabledScenario): boolean {
    if (getOptionsForFeature<BohemiaOptions>(OwsOptionsFeatureType.Bohemia).bohemiaEnabled) {
        switch (scenario) {
            case BohemiaEnabledScenario.MailReadingPane:
                return isFeatureEnabled('rp-prague');
            case BohemiaEnabledScenario.MailCompose:
                return isFeatureEnabled('cmp-prague');
            case BohemiaEnabledScenario.CalendarCompose:
                return isFeatureEnabled('cal-cmp-fluid');
        }
    }
    return false;
}
